module.exports = __webpack_public_path__ + "static/media/alert-boomer.6ef01e9b.png";